import { render, staticRenderFns } from "./sale_detail.vue?vue&type=template&id=b3b83e52&scoped=true&"
import script from "./sale_detail.vue?vue&type=script&lang=js&"
export * from "./sale_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b83e52",
  null
  
)

export default component.exports